/**
 * AWS Amplify auth configuration built from environment variables.
 *
 * Required env vars (set in .env or deployment config):
 *   VITE_COGNITO_USER_POOL_ID   - e.g. us-east-1_AbCdEfGhI
 *   VITE_COGNITO_CLIENT_ID      - App client ID (no secret)
 *   VITE_COGNITO_DOMAIN         - Hosted UI domain prefix
 *   VITE_API_URL                - Backend API base URL
 */

export interface AmplifyAuthConfig {
  Auth: {
    Cognito: {
      userPoolId: string;
      userPoolClientId: string;
      loginWith: {
        oauth: {
          domain: string;
          scopes: string[];
          redirectSignIn: string[];
          redirectSignOut: string[];
          responseType: 'code';
        };
      };
    };
  };
}

export function getAmplifyConfig(): AmplifyAuthConfig {
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '';
  const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID ?? '';
  const rawDomain = import.meta.env.VITE_COGNITO_DOMAIN ?? '';
  // Amplify v6 expects bare domain without protocol
  const domain = rawDomain.replace(/^https?:\/\//, '');
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5174';
  // Redirect must include the /admin/ path to match Cognito callback URLs
  const redirectBase = origin.includes('localhost') ? origin : `${origin}/admin/`;

  return {
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          oauth: {
            domain,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [redirectBase],
            redirectSignOut: [redirectBase],
            responseType: 'code',
          },
        },
      },
    },
  };
}
